var Model = require('../Model');
var model = Object.create(Model);

model.name = 'BacnetDevice';
model['@class'] = 'BacnetDevice';
model.url = 'bacnetdevice';
model.parentClass = 'Segment';
model.isNetworkModel = true;
model.fields = {
  parent: {
    default: null,
    hidden: true
  },
  name: {
    type: 'text',
    default: null,
  },
  address: {
    type: 'text',
    default: null,
  },
  network: {
    type: 'number',
    default: null,
  },
  error: {
    default: null,
  },
  status: {
    default: 'unknown',
  },
  objectId: {
    type: 'number',
    default: null,
  },
  trafficHandlingOverride: {
    type: 'select',
    default: 'inherit',
    options: [
      { name: 'Inherit from BACnet Host', value: 'inherit' },
      { name: 'Sensitive Device', value: 'sensitive' },
    ],
    normalize: function (value) {
      return String(value || '').toLowerCase() === 'sensitive' ? 'sensitive' : 'inherit';
    },
  },
  vendorId: {
    default: null,
    hidden: true,
    runtime: true,
  },
  maxApdu: {
    default: null,
    hidden: true,
    runtime: true,
  },
  segmentation: {
    default: null,
    hidden: true,
    runtime: true,
  },
  lastDiscoveredAt: {
    default: null,
    hidden: true,
    runtime: true,
  }
};

module.exports = model;
